var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 7,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 20C15.5 20 20 15.5 20 10C20 4.5 15.5 -3.93402e-07 10 -8.74228e-07C4.5 -1.35505e-06 1.35505e-06 4.5 8.74228e-07 10C3.93402e-07 15.5 4.5 20 10 20ZM10 5C10.6 5 11 5.4 11 6C11 6.6 10.6 7 10 7C9.4 7 9 6.6 9 6C9 5.4 9.4 5 10 5ZM9 10C9 9.4 9.4 9 10 9C10.6 9 11 9.4 11 10L11 14C11 14.6 10.6 15 10 15C9.4 15 9 14.6 9 14L9 10Z",
    fill: "#F5DD00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.c8f52d7332d099a73e33ff3e611bab61.svg";
export { ForwardRef as ReactComponent };